import {
  //
  FETCH_EVALUATIONS,
  FETCH_EVALUATIONS_FAILURE,
  FETCH_EVALUATIONS_SUCCESS,
  //
  FETCH_RESIDENT_EVALUATIONS,
  FETCH_RESIDENT_EVALUATIONS_FAILURE,
  FETCH_RESIDENT_EVALUATIONS_SUCCESS,
  //
  FETCH_EVALUATION,
  FETCH_EVALUATION_FAILURE,
  FETCH_EVALUATION_SUCCESS,
  //
  SAVE_EVALUATION,
  SAVE_EVALUATION_FAILURE,
  SAVE_EVALUATION_SUCCESS,
  //
  UPDATE_EVALUATION,
  UPDATE_EVALUATION_FAILURE,
  UPDATE_EVALUATION_SUCCESS,
  //
  UPDATE_PLAN_EVALUATION,
  UPDATE_PLAN_EVALUATION_FAILURE,
  UPDATE_PLAN_EVALUATION_SUCCESS,
  //
  UPDATE_PLAN_RESPONSIBLE,
  UPDATE_PLAN_RESPONSIBLE_FAILURE,
  UPDATE_PLAN_RESPONSIBLE_SUCCESS,
} from "./constants";

// List
export const fetchEvaluations = (payload, onSuccess) => ({
  type: FETCH_EVALUATIONS,
  payload,
  onSuccess,
});
export const fetchEvaluationsSuccess = (payload) => ({
  type: FETCH_EVALUATIONS_SUCCESS,
  payload,
});
export const fetchEvaluationsFailure = (payload) => ({
  type: FETCH_EVALUATIONS_FAILURE,
  payload,
});

// Resident-wide list (across all care plans)
export const fetchResidentEvaluations = (payload, onSuccess) => ({
  type: FETCH_RESIDENT_EVALUATIONS,
  payload,
  onSuccess,
});
export const fetchResidentEvaluationsSuccess = (payload) => ({
  type: FETCH_RESIDENT_EVALUATIONS_SUCCESS,
  payload,
});
export const fetchResidentEvaluationsFailure = (payload) => ({
  type: FETCH_RESIDENT_EVALUATIONS_FAILURE,
  payload,
});

// Single
export const fetchEvaluation = (payload, onSuccess) => ({
  type: FETCH_EVALUATION,
  payload,
  onSuccess,
});
export const fetchEvaluationSuccess = (payload) => ({
  type: FETCH_EVALUATION_SUCCESS,
  payload,
});
export const fetchEvaluationFailure = (payload) => ({
  type: FETCH_EVALUATION_FAILURE,
  payload,
});

// Save (Add)
export const saveEvaluation = (payload, onSave) => ({
  type: SAVE_EVALUATION,
  payload,
  onSave,
});
export const saveEvaluationSuccess = (payload) => ({
  type: SAVE_EVALUATION_SUCCESS,
  payload,
});
export const saveEvaluationFailure = (payload) => ({
  type: SAVE_EVALUATION_FAILURE,
  payload,
});

// Update (Edit)
export const updateEvaluation = (payload, onUpdate) => ({
  type: UPDATE_EVALUATION,
  payload,
  onUpdate,
});
export const updateEvaluationSuccess = (payload) => ({
  type: UPDATE_EVALUATION_SUCCESS,
  payload,
});
export const updateEvaluationFailure = (payload) => ({
  type: UPDATE_EVALUATION_FAILURE,
  payload,
});

// Update Plan Evaluation
export const updatePlanEvaluation = (payload, onUpdate) => ({
  type: UPDATE_PLAN_EVALUATION,
  payload,
  onUpdate,
});
export const updatePlanEvaluationSuccess = (payload) => ({
  type: UPDATE_PLAN_EVALUATION_SUCCESS,
  payload,
});
export const updatePlanEvaluationFailure = (payload) => ({
  type: UPDATE_PLAN_EVALUATION_FAILURE,
  payload,
});

// Update Plan Responsible Staff Member
export const updatePlanResponsible = (payload, onUpdate) => ({
  type: UPDATE_PLAN_RESPONSIBLE,
  payload,
  onUpdate,
});
export const updatePlanResponsibleSuccess = (payload) => ({
  type: UPDATE_PLAN_RESPONSIBLE_SUCCESS,
  payload,
});
export const updatePlanResponsibleFailure = (payload) => ({
  type: UPDATE_PLAN_RESPONSIBLE_FAILURE,
  payload,
});
